import { Component, HostListener, Inject, OnInit } from '@angular/core';
//import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss']
})
export class MessagePopupComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      cancelText: string,
      confirmText: string,
      message: string,
      title: string
  }, private mdDialogRef: MatDialogRef<MessagePopupComponent>) { }

  ngOnInit(): void {
  }

  // close(response){
  //   this.mdDialogRef.close(response);
  // }
  public cancel() {
    this.close(false);
  }
public close(value) {
    this.mdDialogRef.close(value);
  }
public confirm() {
    this.close(true);
  }
@HostListener("keydown.esc") 
  public onEsc() {
    this.close(false);
  }

}
